import { each } from 'lodash';
/**
 * @ngdoc directive
 * @name adjust.statistics.directive:scrollTable
 *
 * @description
 * This directive controls the position of the header and the footer while scrolling horizontally
 * It requires {@link adjust.directive:scroll scroll} container directive as parent in order to update about scroll position
 *
 */
function scrollTable(Helper) {
  'ngInject';
  return {
    restrict: 'A',
    scope: {},
    require: ['scrollTable', '^scroll'],
    controller: 'ScrollTableController',
    controllerAs: 'vm',
    link: Helper.linkFunction,
  };
}

/**
 * @ngdoc controller
 * @name adjust.statistics.controller:ScrollTableController
 *
 * @description
 * Controller for the {@link adjust.statistics.directive:scrollTable scrollTable} directive
 *
 */
function ScrollTableController($element) {
  'ngInject';
  var vm = this;

  // eslint-disable-next-line prefer-destructuring
  var _el = $element[0];

  vm.init = init;
  vm.initScroll = initScroll;

  $element.bind('scroll', _handleScroll);
  $element.on('$destroy', _handleDestroy);

  /**
   * @ngdoc method
   * @name init
   * @methodOf adjust.controller:ScrollTableController
   *
   * @description
   * Register parent controller, cache the instance and make scroll table element available in parent
   *
   * @param {Object} parentController parent controller
   *
   */
  function init(parentController) {
    vm.parentController = parentController;

    vm.parentController.setScrollTable($element[0]);
  }

  /**
   * @ngdoc method
   * @name initScroll
   * @methodOf adjust.controller:ScrollTableController
   *
   * @description
   * Initiate the scrolling from the outside
   *
   * @param {number} value scroll position value
   */
  function initScroll(value) {
    _el.scrollLeft += value;
  }

  /**
   * @ngdoc method
   * @name _handleScroll
   * @methodOf adjust.statistics.controller:ScrollTableController
   *
   * @description
   * Handle horizontal scroll, update header and footer position
   *
   * @private
   */
  function _handleScroll() {
    var items = _el.querySelectorAll('.t-scroll');
    var columnWidth = vm.parentController.getSide().offsetWidth;
    var { scrollLeft } = _el;

    each(items, function(item) {
      item.style.left = columnWidth - scrollLeft + 'px';
    });

    vm.parentController.scrollLeft(scrollLeft);
  }

  /**
   * @ngdoc method
   * @name _handleDestroy
   * @methodOf adjust.statistics.controller:ScrollTableController
   *
   * @description
   * Handle destroy event, ensure to unbind events
   *
   * @private
   */
  function _handleDestroy() {
    $element.unbind('scroll', _handleScroll);
  }
}

export { ScrollTableController, scrollTable };
